export enum DocumentType {
  'IMG' = 'IMG',
  'PDF' = 'PDF',
}
